var SupportCancelReservationsServiceActionView, SupportServiceActionButtonTemplate, SupportServiceActionsBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportServiceActionsBaseView = require('./service_action_base');

SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache');

SupportCancelReservationsServiceActionView = (function(superClass) {
  extend(SupportCancelReservationsServiceActionView, superClass);

  function SupportCancelReservationsServiceActionView() {
    return SupportCancelReservationsServiceActionView.__super__.constructor.apply(this, arguments);
  }

  SupportCancelReservationsServiceActionView.prototype.id = 'cancel_reservation';

  SupportCancelReservationsServiceActionView.prototype.initialize = function() {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    this.I18nScope = 'modules.support';
    this.template = SupportServiceActionButtonTemplate;
    return this.order = Groupon.Support.currentOrder;
  };

  SupportCancelReservationsServiceActionView.prototype.render = function() {
    return this.$el.append(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  SupportCancelReservationsServiceActionView.prototype.toHash = function() {
    var hash;
    hash = {
      service_action_id: "cancel_reservation",
      service_action: I18n.t("js.modules.support.cancel_reservation")
    };
    return this.extendHash(hash);
  };

  SupportCancelReservationsServiceActionView.prototype.actionHandler = function(event) {
    var url;
    url = "/users/" + currentUser.id + "/groupons";
    return openLocation(url);
  };

  SupportCancelReservationsServiceActionView.prototype.events = {
    "click #cancel_reservation": "actionHandler"
  };

  return SupportCancelReservationsServiceActionView;

})(SupportServiceActionsBaseView);

module.exports = SupportCancelReservationsServiceActionView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3Mvb3JkZXJfcmVsYXRlZC9zZXJ2aWNlX2FjdGlvbnMvY2FuY2VsX3Jlc2VydmF0aW9uc19zZXJ2aWNlX2FjdGlvbi5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9vcmRlcl9yZWxhdGVkL3NlcnZpY2VfYWN0aW9ucy9jYW5jZWxfcmVzZXJ2YXRpb25zX3NlcnZpY2VfYWN0aW9uLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLDZHQUFBO0VBQUE7OztBQUFBLDZCQUFBLEdBQWdDLE9BQUEsQ0FBUSx1QkFBUjs7QUFDaEMsa0NBQUEsR0FBcUMsT0FBQSxDQUFRLGlEQUFSOztBQUUvQjs7Ozs7Ozt1REFDSixFQUFBLEdBQUk7O3VEQUVKLFVBQUEsR0FBWSxTQUFBO0lBQ1YsQ0FBQyxDQUFDLE9BQU8sQ0FBQyxLQUFWLENBQWdCLENBQWhCLEVBQW1CLENBQUMsSUFBRCxDQUFNLENBQUMsTUFBUCxDQUFjLENBQUMsQ0FBQyxTQUFGLENBQVksSUFBWixDQUFkLENBQW5CO0lBQ0EsSUFBQyxDQUFBLFNBQUQsR0FBYTtJQUNiLElBQUMsQ0FBQSxRQUFELEdBQVk7V0FDWixJQUFDLENBQUEsS0FBRCxHQUFTLE9BQU8sQ0FBQyxPQUFPLENBQUM7RUFKZjs7dURBTVosTUFBQSxHQUFRLFNBQUE7V0FDTixJQUFDLENBQUEsR0FBRyxDQUFDLE1BQUwsQ0FBWSxNQUFBLENBQU8sSUFBQyxDQUFBLFFBQVIsRUFBa0IsSUFBQyxDQUFBLE1BQUQsQ0FBQSxDQUFsQixFQUE2QixJQUFDLENBQUEsU0FBOUIsQ0FBWjtFQURNOzt1REFHUixNQUFBLEdBQVEsU0FBQTtBQUNOLFFBQUE7SUFBQSxJQUFBLEdBQ0U7TUFBQSxpQkFBQSxFQUFvQixvQkFBcEI7TUFDQSxjQUFBLEVBQWlCLElBQUksQ0FBQyxDQUFMLENBQU8sdUNBQVAsQ0FEakI7O1dBRUYsSUFBQyxDQUFBLFVBQUQsQ0FBWSxJQUFaO0VBSk07O3VEQU1SLGFBQUEsR0FBZSxTQUFDLEtBQUQ7QUFDYixRQUFBO0lBQUEsR0FBQSxHQUFNLFNBQUEsR0FBVyxXQUFXLENBQUMsRUFBdkIsR0FBMkI7V0FDakMsWUFBQSxDQUFhLEdBQWI7RUFGYTs7dURBSWYsTUFBQSxHQUNFO0lBQUEsMkJBQUEsRUFBOEIsZUFBOUI7Ozs7O0dBdkJxRDs7QUF5QnpELE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
